import React from 'react'
import {useParams} from "react-router-dom"
import { useFetchData } from '../../../Hooks/Main/useFetchData';
import Image from "react-bootstrap/esm/Image";
import Spinner from 'react-bootstrap/esm/Spinner';
import HtmlDecode from '../../../Utils/HtmlDecode';
import LazyImage from '../../../Components/LazyImage';
const imageUrl = process.env.REACT_APP_FILE_URL

function InvolveDetails() {
    const {id} = useParams()
    const { data, isLoading } = useFetchData(`viewInvolve/${id}`);
  return !isLoading ? (
    <div className="container-fluid p-0">
      <div className="p-0 position-relative d-flex justify-content-center">
              {data?.image ?
                  <LazyImage src={`${imageUrl}${data?.image?.file}`} alt="child labour image"
                    className="img img-fluid"
                    style={{
                        aspectRatio: "5/1",
                        objectFit: "cover",
                        objectPosition: "center",
                        width: "100%",
                      }} /> :
                  <Image
                    src={require(`../../../Assets/Images/slider/childLabour.webp`)}
                    fluid
                    alt="child labour image"
                    bsPrefix="img"
                    style={{
                        aspectRatio: "5/1",
                        objectFit: "cover",
                        objectPosition: "center",
                        width: "100%",
                    }}
                  />
              }
        <div className="image-frame__wrapper">
          <h2>{data?.title}</h2>
        </div>
      </div>
      <div className="container mb-5">
        <div className="row mt-4 mx-1">
                  <div className="col-md-8 mb-3">
                      <div className='my-4 text-center text-muted'> 
                        <span className='mx-5'>Location: <span class="badge text-bg-secondary rounded-pill">{data?.province?.name}</span></span>
                        <span className='mx-5'>Involve for: <span class="badge text-bg-secondary rounded-pill">{data?.related?.name}</span></span>
                      </div>
            <span
                dangerouslySetInnerHTML={{
                    __html: HtmlDecode(data?.content),
                }}
            />
          </div>
          {/* <div className="col-md-4 mb-3 px-4">
            
            <h4 className="fw-light text-center my-3 py-auto">
              <RiArticleLine className="me-2 my-auto fs-5" />
              Latest Article
            </h4>
            <div className="card text-start bg-light border-0">
              <Link to="" className="text-decoration-none articleLink hoverOuterFill">
                <div className="card-body">
                  <div className="card-title py-0 articlesImage shadow">
                    <Image
                      src={require("../../../Assets/Images/child.webp")}
                      fluid
                      rounded
                    ></Image>
                  </div>
                  <div className="card-text mt-3">
                    <p className="text-center fw-light">
                      <small>March 8 2023</small>
                      <small className="mx-2">|</small>
                      <small>Joh Doe</small>
                    </p>
                    <p className="mt-1 fw-light hoverFillColor">
                      Eu irure ea Lorem et laborum ad cillum culpa esse proident
                      culpa reprehenderit adipisicing. Eu irure ea Lorem et
                      laborum ad cillum culpa esse proident culpa reprehenderit
                      adipisicing.
                    </p>
                  </div>
                </div>
              </Link>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  ) : (
    <div className="d-flex justify-content-center mt-3">
      <Spinner animation="grow" className="me-2" />
      Loading Content...
    </div>
  );
}

export default InvolveDetails